// ============================================================
// Isca do Jhow: a conversa no navegador (ADR-036)
// ============================================================
// Roda so no navegador. localStorage pode recusar (aba privada, site bloqueado):
// toda leitura e escrita fica em try/catch e a isca segue funcionando na memoria.
// ============================================================

import type { ConversaAssinada } from './conversa'

export const CHAVE_LOCAL = 'ebuz_jhow_isca'

export function lerConversaLocal(): ConversaAssinada | null {
  try {
    if (typeof window === 'undefined') return null
    const bruto = window.localStorage.getItem(CHAVE_LOCAL)
    return bruto ? (JSON.parse(bruto) as ConversaAssinada) : null
  } catch {
    return null
  }
}

export function salvarConversaLocal(c: ConversaAssinada): void {
  try {
    window.localStorage.setItem(CHAVE_LOCAL, JSON.stringify(c))
  } catch {
    /* sem armazenamento: a conversa vale so enquanto a pagina estiver aberta */
  }
}

export function apagarConversaLocal(): void {
  try {
    window.localStorage.removeItem(CHAVE_LOCAL)
  } catch {
    /* nada a apagar */
  }
}

/** Para a etapa 1: so interessa a conversa com a resposta pronta. */
export function lerSementeLocal(): ConversaAssinada | null {
  const c = lerConversaLocal()
  return c && c.resposta ? c : null
}
